import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||328}
    height={props.width? `calc( ${props.width}/ 328 * 100 )`: 100}
    viewBox="0 0 328 100"
    fill="none"
    style={props.style||{}}
  >
    {/* <path stroke="#000" d="M92.412 55.412 99 62l-6.588 6.588" />
    <path stroke="#000" d="M89.117 55.412 95.705 62l-6.588 6.588" /> */}
    {/* <path
      fill="#000"
      d="M86.934 65.678v-.693c-.432-.049-.772-.136-1.021-.26a1.632 1.632 0 0 1-.621-.549A1.793 1.793 0 0 1 85 63.3l.804-.13c.068.415.207.718.413.909.207.19.446.298.715.32v-2.204a3.442 3.442 0 0 1-1.047-.354 1.373 1.373 0 0 1-.546-.494 1.356 1.356 0 0 1-.2-.74 1.488 1.488 0 0 1 .82-1.33c.245-.124.569-.203.972-.24v-.33h.475v.33c.335.03.616.096.845.205.23.108.42.26.575.455a1.6 1.6 0 0 1 .309.73l-.822.108c-.09-.516-.392-.82-.907-.913v1.998c.364.08.598.137.703.173.238.08.444.184.619.316a1.405 1.405 0 0 1 .57 1.154c-.001.5-.183.905-.547 1.215-.364.31-.812.477-1.345.5v.701h-.475.003Zm0-6.064c-.302.041-.545.146-.727.316a.85.85 0 0 0-.272.65c0 .458.333.774 1 .952v-1.917l-.001-.001Zm.475 4.786c.3-.034.554-.147.762-.34.208-.195.312-.449.312-.765 0-.254-.077-.457-.23-.608-.154-.152-.436-.284-.844-.396V64.4Z"
    /> */}
    {/* <path
      stroke="#000"
      strokeMiterlimit={10}
      d="M148 62.473c0 4.166 3.358 7.544 7.5 7.544 4.142 0 7.5-3.378 7.5-7.544 0-4.167-3.358-7.544-7.5-7.544"
    />
    <path
      fill="#000"
      d="m150.628 55.093 4.872 2.83v-5.66l-4.872 2.83ZM155.282 66v-.7c-.437-.05-.781-.138-1.033-.264a1.643 1.643 0 0 1-.628-.555 1.812 1.812 0 0 1-.296-.888l.814-.132c.069.42.209.728.418.92.209.193.451.303.724.325v-2.231a3.492 3.492 0 0 1-1.061-.358 1.386 1.386 0 0 1-.552-.5 1.374 1.374 0 0 1-.203-.749c0-.286.077-.56.229-.8.153-.239.354-.421.601-.546.248-.125.576-.205.984-.242v-.335h.481v.335c.339.03.624.097.855.207.232.11.426.263.582.46.157.198.261.445.312.739l-.831.11c-.092-.522-.397-.83-.918-.924v2.021c.368.08.605.139.711.175.241.08.45.187.626.32a1.42 1.42 0 0 1 .576 1.167c0 .507-.184.917-.552 1.23-.368.314-.821.483-1.361.507V66h-.481.003Zm0-6.135c-.306.041-.551.147-.735.32a.86.86 0 0 0-.275.658c0 .462.336.782 1.011.962v-1.94h-.001Zm.481 4.843c.304-.034.56-.149.771-.345.21-.197.315-.454.315-.774 0-.256-.077-.462-.233-.615-.155-.154-.44-.287-.853-.4v2.134Z"
    /> */}
    <path
      fill="#C7C7C7"
      d="M38.418 77.371c21.13 0 38.26-17.13 38.26-38.26S59.548.854 38.418.854.16 17.982.16 39.112s17.13 38.26 38.26 38.26Z"
    />
    <path fill="#D2D2D2" d="M38.419 31.13 15.995 70.626H38.42V31.13Z" />
    <path fill="#858585" d="M60.842 70.627 38.42 31.13v39.498h22.423Z" />
    <path
      fill="#E6E6E6"
      d="M51.63 17.909 38.41 4.688l-13.221 13.22 13.22 13.221L51.63 17.91Zm-21.13 0L38.42 9.99l7.918 7.918-7.918 7.917-7.918-7.918Z"
    />
    <path fill="#00C9D6" d="M92.5 27.5 100 18l-7.5 -8.5L85 18z" />

    {/* <text
      style={{
        fill: "black",
        fontWeight: 700,
        fontSize: 15,
        letterSpacing: ".07em",
      }}
      transform="translate(0 0)"
    >
      <tspan x={82} y={20}>
        {props.name} Co.
      </tspan>
    </text> */}

    <text
      style={{
        fill: "black",
        fontWeight: 700,
        fontSize: 15,
        letterSpacing: ".07em",
      }}
      transform="translate(0 0)"
    >
      <tspan x={110} y={23}>
        {props.name} Co.
      </tspan>
    </text>

    <text
      style={{
        fill: "black",
        fontWeight: 600,
        fontSize: 12,
        letterSpacing: ".07em",
      }}
      transform="translate(0 0)"
    >
      <tspan x={81} y={40}>
        Comp Val.: ${props.solvencyRatio}
      </tspan>
    </text>

    {/* <text
      style={{
        fill: "black",
        fontWeight: 600,
        fontSize: 12,
        letterSpacing: ".07em",
      }}
      transform="translate(0 0)"
    >
      <tspan x={81} y={55}>
        {props.name} Co. Val.: {props.companyValuation}
      </tspan>
    </text> */}

    {/* <text
      style={{
        fill: Number(props.ROC)>=0?'green':'red',
        fontWeight: 700,
        fontSize: 12,
        letterSpacing: ".07em",
      }}
      transform="translate(0 0)"
    >
      <tspan x={81} y={70}>
        Cum Inv Ret: {props.ROC>=0?'+':''}{props.ROC}%
      </tspan>
    </text> */}

  


  </svg>
)
export default SvgComponent
